<template>
  <div>
    <b-modal
      id="modal-orders"
      centered
      title="Подключить мобипакет"
      ok-title="Подключить"
      cancel-title="Закрыть"
      cancel-variant="outline-secondary"
      size="sm"
      ref="vuemodal"
      class="mb-5 modal-mb"
      @ok="acceptOrder"
      v-model="statusModal"
      @hide="hide"
      no-close-on-backdrop
    >
      <validation-observer
        ref="simpleRules"
      >
        <b-form @submit.stop.prevent="handleSubmit">
          <b-row class="mb-1">
            <b-col cols="7" class="pr-0">
              <b-alert
                variant="secondary"
                show
                class="w-100 h-100 alert-num-cat"
              >
                <h1 class="alert-heading">{{ name }}</h1>
                <div class=" py-0 alert-body">
                  <p class="p-0">{{ zone }}</p>
                </div>
              </b-alert>
            </b-col>
            <b-col cols="5">
              <b-alert
                variant="secondary"
                show
                class="w-100 h-100 alert-price"
              >
                <div class="h-100 w-100 text-center d-flex align-items-center justify-content-center ">
                  <div>
                    <h1 class="w-100 d-block">
                      {{ amount }}
                    </h1>
                    <p>
                      сомони
                    </p>
                  </div>
                </div>
              </b-alert>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <p>Вводите номер, которой хотите подключить мобипакет. Вам отправиться SMS с кодом для подтверждения.</p>
              <b-form-group
                label="Номер телефона"
                label-for="phoneNumber"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Номер телефона"
                  rules="required"
                >
                  <b-row>
                    <b-col :cols="checkBalanceStatus ? 8 : 12">
                      <b-form-input
                        type="number"
                        placeholder="Номер телефона"
                        v-model="clientPhoneNumber"
                        data-layout="numeric" @focus="show"
                      />
                    </b-col>
                    <b-col cols="4" v-show="checkBalanceStatus">
                      <b-button
                        variant="outline-secondary"
                        class=""
                        @click="checkBalance"
                      >
                        Баланс
                      </b-button>
                    </b-col>
                  </b-row>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" v-show="!checkBalanceStatus">
              <div class="pt-1 d-flex justify-content-center">
                <VueRecaptcha ref="recaptchaPacket" :sitekey="this.sitekey" :loadRecaptchaScript="true"
                              @verify="markRecaptchaAsVerified" @expired="onCaptchaExpired"/>
              </div>
              <p><small class="text-danger">{{ pleaseTickRecaptchaMessage }}</small></p>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal
      id="verify-modal"
      centered
      title="Верификация номер телефона"
      ok-title="Подвердить"
      cancel-title="Закрыть"
      cancel-variant="outline-secondary"
      size="sm"
      ref="verifyModal"
      class="mb-5"
      @ok="verifyAndAcceptOrder"
      v-model="statusModalVerify"
      no-close-on-backdrop
    >
      <div v-show="MessageContent" ref="MessageContent">
        <p ref="MessageLabel">{{ MessageLabel }}</p>
      </div>
      <validation-observer
        ref="verifyRules"
        v-show="verifyRules"
      >
        <b-form @submit.stop.prevent="handleSubmitVerify">
          <b-col cols="12">
            <p>SMS с кодом отправлен на номер {{ clientPhoneNumber }}</p>
            <b-form-group
              label="Вводите код подтверждения"
              label-for="verifyCode"
            >
              <validation-provider
                #default="{ errors }"
                name="Код подтверждения"
                rules="required"
              >
                <b-form-input
                  type="number"
                  placeholder="Код подтверждения"
                  v-model="verifyCode"
                  data-layout="numeric" @focus="show"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-form>
      </validation-observer>

      <template #modal-footer v-if="MessageContent">
        <div class="w-100">
          <b-button
            variant="outline-secondary"
            class="float-right"
            @click="hideAllModal"
          >
            Закрыть
          </b-button>
        </div>
      </template>

    </b-modal>
    <vue-touch-keyboard :options="options" v-if="visible" :layout="layout" :cancel="hide" :accept="accept"
                        :input="input"/>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BModal,
  BForm,
  BFormInput,
  BFormGroup,
  BAlert,
  BButton,
} from 'bootstrap-vue'
import ru from 'vee-validate/dist/locale/ru.json'
import VueRecaptcha from 'vue-recaptcha'
import {
  ValidationProvider,
  ValidationObserver,
  localize,
} from 'vee-validate'
import {
  required,
} from '@validations'
import '@/@core/components/app-keyboard/vue-touch-keyboard/dist/vue-touch-keyboard.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BButton,
    BRow,
    BCol,
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BAlert,
    VueRecaptcha,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      zone: '',
      duration: '',
      name: '',
      amount: '',
      clientPhoneNumber: '',
      verifyCode: '',
      sitekey: '6LfSmYcaAAAAAAd_8EeRyTZj_i9LXXDrAJ68eaXq',
      url: '',
      statusModal: false,
      submittedNames: [],
      required,
      verifyRules: true,
      MessageContent: false,
      MessageLabel: '',
      statusModalVerify: false,
      recaptchaVerified: false,
      pleaseTickRecaptchaMessage: '',
      recaptchaToken: '',
      checkBalanceStatus: false,
      sensorActive: false,
      visible: false,
      layout: 'normal',
      input: null,
      options: {
        useKbEvents: false,
      },
    }
  },
  methods: {
    showModal(zone, name, amount, duration) {
      this.zone = zone
      this.amount = amount
      this.name = name
      this.duration = duration
      this.clearInputs()
      this.$refs.vuemodal.show()
    },
    clearInputs() {
      this.clientPhoneNumber = ''
      this.verifyCode = ''
    },
    acceptOrder(ev) {
      ev.preventDefault()
      this.handleSubmit()
    },
    verifyAndAcceptOrder(ev) {
      ev.preventDefault()
      this.handleSubmitVerify()
    },
    validateModalForm() {
      const that = this
      that.$refs.simpleRules.validate().then(success => {
        if (!success) {
          return
        }
        if (!that.checkBalanceStatus && !that.recaptchaVerified) {
          that.pleaseTickRecaptchaMessage = 'Пожалуйста, отметьте ReCaptcha.'
          return // prevent form from submitting
        }
        const formData = new FormData()

        formData.append('clientPhoneNumber', that.clientPhoneNumber)
        formData.append('recaptchaToken', that.recaptchaToken)
        if (this.checkBalanceStatus) {
          this.validateModalVerifyForm()
        } else {
          that.$http.post(`${this.url}/api/verify-code`,
            formData,
            {
              headers: {
                'Content-Type': 'application/json',
              },
            })
            .then(response => {
              if (response.data === 1) {
                that.verifyRules = true
                that.MessageContent = false
                that.$refs.verifyModal.show()
              }
            }).catch()
        }
      })
    },
    validateModalVerifyForm() {
      const that = this
      if (that.MessageContent) {
        that.verifyRules = true
        that.MessageContent = false
        that.MessageLabel = ''
        that.verifyCode = ''
        that.$refs.vuemodal.hide()
        that.$refs.verifyModal.hide()
        return
      }
      if (that.checkBalanceStatus) {
        that.connectPacket()
      } else {
        that.$refs.verifyRules.validate().then(success => {
          if (!success) {
            return
          }
          that.connectPacket()
        })
      }
    },
    connectPacket() {
      const that = this
      const formData = new FormData()
      formData.append('packet_name', `${this.name}-${this.amount} (${this.zone}) ${this.duration}`)
      formData.append('clientPhoneNumber', this.clientPhoneNumber)
      formData.append('verify_code', this.verifyCode)

      that.$http.post(`${this.url}/api/packet/connect`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(response => {
          const {
            data,
          } = response
          if (data === 0) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Ошибка',
                icon: 'XIcon',
                variant: 'danger',
                text: 'Неверный код подтверждения.',
              },
            })
          } else {
            that.verifyRules = false
            that.MessageContent = true
            that.MessageLabel = data.comment
            that.$refs.verifyModal.show()
            if (data.code) {
              const codes = JSON.parse(localStorage.getItem('packetCodes')) ?? []
              codes.push(data.code)
              localStorage.setItem('packetCodes', JSON.stringify(codes))
            }
            // if (that.checkBalanceStatus) {
            //   that.$refs.verifyModal.show()
            // } else {
            //   that.$refs.verifyModal.hide()
            // }
          }
        }).catch()
    },
    handleSubmit() {
      this.validateModalForm()
    },
    handleSubmitVerify() {
      this.validateModalVerifyForm()
    },
    validate() {
      this.$refs.recaptchaPacket.execute()
    },
    hideAllModal() {
      this.statusModal = false
      this.statusModalVerify = false
      this.hide()
    },
    markRecaptchaAsVerified(response) {
      this.recaptchaToken = response
      this.pleaseTickRecaptchaMessage = ''
      this.recaptchaVerified = true
    },
    onCaptchaExpired() {
      this.$refs.recaptchaPacket.reset()
    },
    checkBalanceStatusButton() {
      if (this.userData && this.userData.access_token) {
        this.checkBalanceStatus = true
      } else {
        this.checkBalanceStatus = false
      }
    },
    checkBalance() {
      const that = this
      that.$refs.simpleRules.validate().then(success => {
        if (!success) {
          return
        }
        const formData = new FormData()

        formData.append('clientPhoneNumber', that.clientPhoneNumber)

        that.$http.post(`${this.url}/api/dealer/check-balance`,
          formData,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then(response => {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Баланс ${this.clientPhoneNumber}`,
                icon: 'CheckIcon',
                variant: 'warning',
                text: `${response.data}`,
              },
            })
          }).catch()
      })
    },
    accept(text) {
      console.log(text)
      this.hide()
    },
    show(e) {
      if (this.sensorActive) {
        if (e) {
          this.input = e.target
          this.layout = e.target.dataset.layout
        }

        if (!this.visible) {
          this.visible = true
        }
      } else {
        this.visible = false
      }
    },
    hide() {
      this.visible = false
    },
  },
  created() {
    this.url = 'https://tojtel.tj'
    localize('ru', ru)
    this.hideAllModal()
    this.checkBalanceStatusButton()
    if (this.$route.query.sensor && this.$route.query.sensor === 'active') {
      this.sensorActive = true
    } else {
      this.sensorActive = false
    }
  },
  updated() {
    this.checkBalanceStatusButton()
  },
}
</script>

<style scoped>
.alert-secondary {
  background-color: #f7f6fc !important;
}

.alert p {
  font-weight: 400;
  color: #3a3746;
}

.alert-num-cat {
  /*border-top-right-radius: 0;*/
  /*border-bottom-right-radius: 0;*/
}

.alert-heading {
  color: #3a3746;
  font-size: 25px;
  box-shadow: none;
}

.alert-price {
  /*border-top-left-radius: 0;*/
  /*border-bottom-left-radius: 0;*/
}

.alert-price h1 {
  font-size: 30px;
  line-height: 25px;
}

modal-mb {
  margin-bottom: 150px;
}
</style>
